// extracted by mini-css-extract-plugin
module.exports = {"container":"ServicesList_container__1skSD","listItem":"ServicesList_listItem__2GQEg","leftIcon":"ServicesList_leftIcon__2BjaK"};